import { render, staticRenderFns } from "./Disturb.vue?vue&type=template&id=276a1822&scoped=true"
import script from "./Disturb.vue?vue&type=script&lang=js"
export * from "./Disturb.vue?vue&type=script&lang=js"
import style0 from "./Disturb.vue?vue&type=style&index=0&id=276a1822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a1822",
  null
  
)

export default component.exports